import { render, staticRenderFns } from "./index_v1.vue?vue&type=template&id=3c82f8d6&scoped=true"
import script from "./index_v1.vue?vue&type=script&lang=js"
export * from "./index_v1.vue?vue&type=script&lang=js"
import style0 from "./index_v1.vue?vue&type=style&index=0&id=3c82f8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c82f8d6",
  null
  
)

export default component.exports